import {joinURL} from 'ufo'
import type {ProviderGetImage} from '@nuxt/image'

export const getImage: ProviderGetImage = (src, {modifiers = {}, baseURL} = {}) => {
    const url = joinURL(useRuntimeConfig().public.cdnBaseUrl, src);
    return {url};
}